import { render } from "./SearchPopularList.vue?vue&type=template&id=1ef6286c&scoped=true&ts=true"
import script from "./SearchPopularList.vue?vue&type=script&lang=ts"
export * from "./SearchPopularList.vue?vue&type=script&lang=ts"

import "./SearchPopularList.vue?vue&type=style&index=0&id=1ef6286c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef6286c"]])

export default __exports__